import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const IndicativeMarketValuationIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 45 45" fill="none" {...props}>
    {/* Outer circle */}
    <path
      d="M22.5 0.75C34.5122 0.75 44.25 10.4878 44.25 22.5C44.25 34.5122 34.5122 44.25 22.5 44.25C10.4878 44.25 0.75 34.5122 0.75 22.5C0.75 10.4878 10.4878 0.75 22.5 0.75Z"
      stroke="currentColor"
      strokeOpacity="0.4"
      strokeWidth="1.5"
      fill="none"
    />

    {/* Expand / resize symbol */}
    <path
      d="M28.2292 16.7708L16.7708 28.2292M18.8542 20.9375V16.7708M16.7708 18.8542H20.9375M24.0625 26.1458H28.2292M18.125 31.875H26.875C28.6252 31.875 29.5002 31.875 30.1687 31.5344C30.7567 31.2348 31.2348 30.7567 31.5344 30.1687C31.875 29.5002 31.875 28.6252 31.875 26.875V18.125C31.875 16.3748 31.875 15.4998 31.5344 14.8313C31.2348 14.2433 30.7567 13.7652 30.1687 13.4656C29.5002 13.125 28.6252 13.125 26.875 13.125H18.125C16.3748 13.125 15.4998 13.125 14.8313 13.4656C14.2433 13.7652 13.7652 14.2433 13.4656 14.8313C13.125 15.4998 13.125 16.3748 13.125 18.125V26.875C13.125 28.6252 13.125 29.5002 13.4656 30.1687C13.7652 30.7567 14.2433 31.2348 14.8313 31.5344C15.4998 31.875 16.3748 31.875 18.125 31.875Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
